import { Component, Input } from '@angular/core';
import { NavigationItem } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent {
  @Input() current_nav_item?: NavigationItem;
  @Input() width_class: string = 'sp-toolbar__closed-width';

  constructor(private utils_service: UtilsService) {}

  ngOnInit(): void {}

  getProfileLabel(): string {
    return this.utils_service.getProfileShrinkedUsername();
  }

  getProfileEmail(): string {
    return this.utils_service.getProfileEmail();
  }
}
